import React from "react";

import KPIComparison from "components/visuals/KPIComparison";
import useColourPalette from "components/visuals/useColourPalette";
import { Box, Typography } from "@material-ui/core";
import { useAppSelector } from "store";
import { selectIsLoading, selectHasErrors, selectLastTwelveMonthsTotalVisits, selectFootfallCentiles } from "modules/customer/tools/location/footfallNew/footfallSlice";
import numberFormatter from "utils/numberFormatter";
import { selectComparatorsByChapter } from "modules/customer/tools/location/locationSlice";

const LastTwelveMonthsTotalVisits: React.FC = () => {
    const colourPalette = useColourPalette();
    const comparators = useAppSelector(selectComparatorsByChapter);
    const isLoading = useAppSelector(selectIsLoading);
    const hasErrors = useAppSelector(selectHasErrors);
    const lastTwelveMonthsTotalVisits = useAppSelector(selectLastTwelveMonthsTotalVisits);
    const centiles = useAppSelector(selectFootfallCentiles);

    const selectedLocationValueString = `${numberFormatter.toDecimalPlaces(lastTwelveMonthsTotalVisits.selectedStore, 1)}`;
    const selectedLocationCentileString = `${numberFormatter.toOrdinalNumber(centiles.selectedLocation)}`;
    const comparatorValueString = `${numberFormatter.toDecimalPlaces(lastTwelveMonthsTotalVisits.comparator, 1)}`;
    const comparatorCentileString = `${numberFormatter.toOrdinalNumber(centiles.comparator)}`;
    const differencePositiveSign = lastTwelveMonthsTotalVisits.percentageDifference > 0 ? "+" : "";

    const label = `Average annual visits per cell within the selected retail centre`;
    return (
        <Box width="100%" height="100%" data-cy="average-annual-visits-per-cell">
            <KPIComparison
                isLoading={isLoading}
                hasErrors={hasErrors}
                targetValue={
                    <Typography variant="h3" component="div" style={{ color: colourPalette.comparators[0] }}>
                        {`${selectedLocationValueString} (${selectedLocationCentileString})`}
                    </Typography>
                }
                targetLabel={label}
                comparisonValue={
                    <Typography variant="h6" component="div" style={{ color: colourPalette.comparators[1] }}>
                        {`${comparatorValueString} (${comparatorCentileString})`}
                    </Typography>
                }
                comparisonLabel={`Comparator: ${comparators?.footfall.storeName}`}
                differenceValue={
                    <Typography variant="h6" component="div" style={{ color: "#FFFFFF" }}>
                        {differencePositiveSign}{numberFormatter.toPercentage(lastTwelveMonthsTotalVisits.percentageDifference)}
                    </Typography>}
                differenceLabel="Difference"
            />
        </Box>
    );
};

export default LastTwelveMonthsTotalVisits;
